<template>
  <Transition name="modal">
    <div v-if="showModal" class="modal-container">
      <div class="modal-mask" @click="() => hideModal()"></div>
      <div class="modal-body">
        <component :is="currentModal.component" :params="params" @closeModal="() => hideModal()" />
        <div class="modal-close">
          <i class="icon-closethin" @click="() => hideModal()"></i>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { mapGetters } from 'vuex';
import AdminFormCreate from '@/views/admin/Form/Create';
import ShareStudy from '@/components/Modal/ShareStudy';
import DeleteStudy from '@/components/Modal/DeleteStudy';
import DeleteAccount from '@/components/Modal/DeleteAccount';
import StudyParameters from '@/components/Modal/StudyParameters';
import ExportStudy from '@/components/Modal/ExportStudy';
import ExportStudyList from '@/components/Modal/ExportStudyList';
import ExportLoading from '@/components/Modal/ExportLoading';
import OutlierDetail from '@/components/Map/Analysis/Detail/Outlier';
import TransportDetail from '@/components/Map/Analysis/Detail/TransportDetail';

export default {
  components: {
    AdminFormCreate,
    ShareStudy,
    DeleteStudy,
    DeleteAccount,
    StudyParameters,
    ExportStudy,
    ExportStudyList,
    ExportLoading,
    OutlierDetail,
    TransportDetail,
  },

  computed: {
    ...mapGetters(['currentModal']),

    params() {
      return this.currentModal.params;
    },

    showModal() {
      return this.currentModal.component;
    },
  },

  methods: {
    hideModal() {
      this.$store.dispatch('updateCurrentModal', {
        component: null,
        params: null,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}
.modal-mask {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
}
.modal-body {
  position: relative;
  z-index: 1;
  transition: all 0.3s ease;
  background-color: white;
  padding: 32px;
  box-sizing: border-box;
  min-width: 360px;
  border-radius: 4px;
  border: 1px solid #e3e3e3;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
  max-height: 90vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.modal-close {
  position: absolute;
  right: 0;
  top: 0;
  margin: 0.3em;
  i {
    font-size: 1.5em;
    color: colors.$red-color;
    cursor: pointer;
    transition: color 0.3s ease;
    &:hover {
      color: #262631;
    }
  }
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-body,
.modal-leave-active .modal-body {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
